import { render, staticRenderFns } from "./WebhooksRetrieveUpdate.vue?vue&type=template&id=200a9fac"
import script from "./WebhooksRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./WebhooksRetrieveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports